
const viewproduct = {
  label: "View Product",
  pageLabel: "View Product",
  starting: true,
  url: "viewproduct",
  pageType: "history",
  formTabs: {
    allTabs: [
      { label: "Product", uid: "product", style: { fontFamily: "verdana" } },
       { label: "General Information", uid: "generalInfo", style: { fontFamily: "verdana" } },
      { label: "Interest", uid: "interest", style: { fontFamily: "verdana" } },
       { label: "Deposit", uid: "deposit", style: { fontFamily: "verdana" } },
     { label: "Loan", uid: "loan", style: { fontFamily: "verdana" } },
      {
        label: "SMS Parameters",
        uid: "smsparameter",
        style: { fontFamily: "verdana" }
      },
      {
        label: "Loan Columns",
        uid: "loancolumns",
        style: { fontFamily: "verdana" }
      }
    ]
  },
  form: [
    {
      inputType: "displaytext",
      tab: "product",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "",
      label: "Code",
      name: "",
      description: "Enter Code"
    },
    {
      inputType: "text",
      tab: "product",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "Code",
      name: "code",
      description: "Enter Code"
    },
    {
      inputType: "displaytext",
      tab: "product",
      widths: {
        parent: "col-sm-8",
        children: "col-sm-12"
      },
      placeHolder: "",
      label: "",
      name: "",
      description: "Enter Code"
    },

    {
      inputType: "displaytext",
      tab: "product",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "Name",
      label: "Name",
      name: "",
      description: "Enter Name"
    },
    {
      inputType: "text",
      tab: "product",
      widths: {
        parent: "col-sm-4",
        children: "col-sm-12"
      },
      placeHolder: "Name",
      name: "Name",
      description: "Enter Name"
    },
    {
      inputType: "displaytext",
      tab: "product",
      widths: {
        parent: "col-sm-6",
        children: "col-sm-12"
      },
      placeHolder: "",
      label: "",
      name: "",
      description: "Enter Code"
    },
    {
      inputType: "displaytext",
      tab: "product",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "Name in Marathi",
      label: "Name in Marathi",
      name: "",
      description: "Enter Name in Marathi"
    },
    {
      inputType: "text",
      tab: "product",
      widths: {
        parent: "col-sm-4",
        children: "col-sm-12"
      },
      placeHolder: "Name in Marathi",
      name: "Nameinmarathi",
      description: "Enter Name in Marathi"
    },
    {
      inputType: "displaytext",
      tab: "product",
      widths: {
        parent: "col-sm-6",
        children: "col-sm-12"
      },
      placeHolder: "",
      label: "",
      name: "",
      description: ""
    },

    // {
    //   inputType: "displaytext",
    //   tab: "product",
    //   widths: {
    //     parent: "col-sm-2",
    //     children: "col-sm-12"
    //   },
    //   placeHolder: "",
    //   label: "Regionl Name",
    //   name: "",
    //   description: "Enter Regionl Name"
    // },

    // {
    //   inputType: "text",
    //   tab: "product",
    //   widths: {
    //     parent: "col-sm-2",
    //     children: "col-sm-12"
    //   },
    //   placeHolder: "Regionl Name",
    //   name: "RegionlName",
    //   description: "Enter Regionl Name"
    // },

    {
      inputType: "displaytext",
      tab: "product",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "",
      label: "Product Group",
      name: "",
      description: "Enter Product Group"
    },
    {
      inputType: "select",
      tab: "product",
      default: "",
      widths: {
        parent: "col-sm-4",
        children: "col-sm-12"
      },
      options: [
        {
          label: "Individual",
          value: "individual"
        },
        {
          label: "Internal",
          value: "internal"
        },
        {
          label: "Other",
          value: "other"
        }
      ],
      placeHolder: "Product Group",
      name: "ProductGroup",
      description: "Enter Product Group"
    },
    {
      inputType: "displaytext",
      tab: "product",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "",
      label: "Product Type",
      name: "",
      description: "Enter Product Type"
    },
    {
      inputType: "select",
      tab: "product",
      default: "",
      widths: {
        parent: "col-sm-4",
        children: "col-sm-12"
      },
      options: [
        {
          label: "Individual",
          value: "individual"
        },
        {
          label: "Internal",
          value: "internal"
        },
        {
          label: "Other",
          value: "other"
        }
      ],

      placeHolder: "Product Type",
      name: "ProductType",
      description: "Enter Product Type"
    },
    
    {
      inputType: "displaytext",
      tab: "product",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "",
      label: "General Ledger",
      name: "",
      description: "Enter General Ledger"
    },

    {
      inputType: "text",
      tab: "product",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "General Ledger",
      name: "GeneralLedger",
      description: "Enter General Ledger"
    },
    
    {
      inputType: "checkbox",
      isRequired: true,
      default: "true",
      tab: "product",
      widths: {
        parent: "col-sm-4",
        children: "col-sm-12"
      },
      placeHolder: "input with checkbox",
      label: "Active",
      name: "active",
      description: "Active"
    },

    {
      inputType: "checkbox",
      isRequired: true,
      default: "false",
      tab: "generalInfo",
      widths: {
        parent: "col-sm-6",
        children: "col-sm-12"
      },
      placeHolder: "input with checkbox",
      label: "Allow Transaction even if KYC not Done",
      name: "AllowTransaction",
      description: "Allow Transaction"
    },
    {
      inputType: "displaytext",
      tab: "generalInfo",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "",
      label: "Minimum Balance Type",
      name: "",
      description: "Enter Minimum Balance Type"
    },
    {
      inputType: "select",
      tab: "generalInfo",
      widths: {
        parent: "col-sm-4",
        children: "col-sm-12"
      },
      options: [
        {
          label: "Individual",
          value: "individual"
        },
        {
          label: "Internal",
          value: "internal"
        },
        {
          label: "Other",
          value: "other"
        },
       ],
      placeHolder: "Minimum Balance Type",
      name: "MinimumBalanceType",
      description: "Enter Minimum Balance Type"
    },
    {
      inputType: "checkbox",
      isRequired: true,
      default: "false",
      tab: "generalInfo",
      widths: {
        parent: "col-sm-6",
        children: "col-sm-12"
      },
      placeHolder: "input with checkbox",
      label: "Internet Banking",
      name: "InternetBanking",
      description: "Internet Banking"
    },
    
    {
      inputType: "displaytext",
      tab: "generalInfo",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "",
      label: "Minimum Balance",
      name: "",
      description: "Enter Minimum Balance"
    },
    
   {
      inputType: "text",
      tab: "generalInfo",
      widths: {
        parent: "col-sm-4",
        children: "col-sm-12"
      },
      placeHolder: "Minimum Balance",
      name: "MinimumBalance",
      description: "Enter Minimum Balance"
    },
    {
      inputType: "checkbox",
      isRequired: true,
      default: "false",
      tab: "generalInfo",
      widths: {
        parent: "col-sm-6",
        children: "col-sm-12"
      },
      placeHolder: "input with checkbox",
      label: "Mobile Banking",
      name: "MobileBanking",
      description: "Mobile Banking"
    },
    {
      inputType: "checkbox",
      isRequired: true,
      default: "false",
      tab: "generalInfo",
      widths: {
        parent: "col-sm-6",
        children: "col-sm-12"
      },
      placeHolder: "input with checkbox",
      label: "Allow Transaction Below Minimum Balance",
      name: "AllowTransactionBelowMinimumBalance",
      description: "Allow Transaction Below Minimum Balance"
    },
    {
      inputType: "checkbox",
      isRequired: true,
      default: "false",
      tab: "generalInfo",
      widths: {
        parent: "col-sm-12",
        children: "col-sm-12"
      },
      placeHolder: "input with checkbox",
      label: "Nomination",
      name: "Nomination",
      description: "Nomination"
    },
     {
      inputType: "checkbox",
      isRequired: true,
      default: "false",
      tab: "generalInfo",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "input with checkbox",
      label: "OD Facility",
      name: "ODFacility",
      description: "ODFacility"
    },
        
    {
      inputType: "displaytext",
      tab: "generalInfo",
      widths: {
        parent: "col-sm-3",
        children: "col-sm-12"
      },
      placeHolder: "",
      label: "Maximum Overdraft Amount",
      name: "",
      description: "Enter Maximum Overdraft Amount"
    },
     {
      inputType: "text",
      tab: "generalInfo",
      widths: {
        parent: "col-sm-3",
        children: "col-sm-12"
      },
      placeHolder: "Maximum Overdraft Amount",
      name: "MaximumOverdraftAmount",
      description: "Enter Maximum Overdraft Amount"
    },
    {
      inputType: "displaytext",
      tab: "generalInfo",
      widths: {
        parent: "col-sm-4",
        children: "col-sm-12"
      },
      placeHolder: "",
      label: "",
      name: "",
      description: "Enter Maximum Overdraft Amount"
    },
    {
      inputType: "checkbox",
      isRequired: true,
      default: "false",
      tab: "generalInfo",
      widths: {
        parent: "col-sm-6",
        children: "col-sm-12"
      },
      placeHolder: "Allow Zero Balance",
      label: "Allow Zero Balance",
      name: "AllowZeroBalance",
      description: "Allow Zero Balance"
    },
    {
      inputType: "displaytext",
      tab: "generalInfo",
      widths: {
        parent: "col-sm-3",
        children: "col-sm-12"
      },
      placeHolder: "",
      label: "Staement in Transaction",
      name: "",
      description: "Staement in Transaction"
    },
     {
      inputType: "text",
      tab: "generalInfo",
      widths: {
        parent: "col-sm-3",
        children: "col-sm-12"
      },
      placeHolder: "Staement in Transaction",
      name: "StaementTransaction",
      description: "Staement in Transactiont"
    },
    {
      inputType: "checkbox",
      isRequired: true,
      default: "false",
      tab: "generalInfo",
      widths: {
        parent: "col-sm-6",
        children: "col-sm-12"
      },
      placeHolder: "Closing Charges Applicable",
      label: "Closing Charges Applicable",
      name: "ClosingApplicable",
      description: "Closing Charges Applicable"
    },
    {
      inputType: "displaytext",
      tab: "generalInfo",
      widths: {
        parent: "col-sm-3",
        children: "col-sm-12"
      },
      placeHolder: "",
      label: "FIU-IND(CTR)Account Type",
      name: "",
      description: "FIU-IND(CTR)Account Type"
    },
     {
      inputType: "text",
      tab: "generalInfo",
      widths: {
        parent: "col-sm-3",
        children: "col-sm-12"
      },
      placeHolder: "FIU-IND(CTR)Account Type",
      name: "accttype",
      description: "FIU-IND(CTR)Account Type"
    },
    {
      inputType: "checkbox",
      isRequired: true,
      default: "false",
      tab: "generalInfo",
      widths: {
        parent: "col-sm-6",
        children: "col-sm-12"
      },
      placeHolder: "ABB Charges Applicable",
      label: "ABB Charges Applicable",
      name: "ABBApplicable",
      description: "ABB Charges Applicable"
    },
    {
      inputType: "displaytext",
      tab: "generalInfo",
      widths: {
        parent: "col-sm-3",
        children: "col-sm-12"
      },
      placeHolder: "",
      label: "TM Code",
      name: "",
      description: "TM Code"
    },
     {
      inputType: "text",
      tab: "generalInfo",
      widths: {
        parent: "col-sm-3",
        children: "col-sm-12"
      },
      placeHolder: "TM Code",
      name: "tmcode",
      description: "TM Code"
    },
    {
      inputType: "checkbox",
      isRequired: true,
      default: "false",
      tab: "generalInfo",
      widths: {
        parent: "col-sm-6",
        children: "col-sm-12"
      },
      placeHolder: "NEFT/RTGS Allow",
      label: "NEFT/RTGS Allow",
      name: "NEFTRTGS",
      description: "NEFT/RTGS Allow"
    },

    {
      widths: "col-sm-12",
      tab: "generalInfo",
      subComponents: [
        {
          inputType: "displaytext",
          widths: {
            parent: "col-sm-12",
            children: "col-sm-12"
          },
          placeHolder: "",
          label: "Transaction Limit",
          name: "",
          description: ""
        },
        {
          inputType: "checkbox",
          isRequired: true,
          default: "false",
          widths: {
            parent: "col-sm-3",
            children: "col-sm-12"
          },
          placeHolder: "Transaction Limit",
          label: "Transaction Limit",
          name: "transactionlimit",
          description: "Transaction Limit"
        },
        {
          inputType: "displaytext",
          widths: {
            parent: "col-sm-2",
            children: "col-sm-12"
          },
          placeHolder: "",
          label: "Receipt",
          name: "",
          description: ""
        },
        {
          inputType: "displaytext",
          widths: {
            parent: "col-sm-2",
            children: "col-sm-12"
          },
          placeHolder: "",
          label: "Payment",
          name: "",
          description: ""
        },
        {
          inputType: "displaytext",
          widths: {
            parent: "col-sm-5",
            children: "col-sm-12"
          },
          placeHolder: "",
          label: "",
          name: "",
          description: ""
        },
        {
          inputType: "displaytext",
          widths: {
            parent: "col-sm-3",
            children: "col-sm-12"
          },
          placeHolder: "",
          label: "Maximum Cash",
          name: "",
          description: ""
        },
        {
          inputType: "text",
          widths: {
            parent: "col-sm-2",
            children: "col-sm-12"
          },
          placeHolder: "",
          label: "",
          name: "maximumcashreceipt",
          description: ""
        },
        {
          inputType: "text",
          widths: {
            parent: "col-sm-2",
            children: "col-sm-12"
          },
          placeHolder: "",
          label: "",
          name: "maximumcashpayment",
          description: ""
        },
        {
          inputType: "displaytext",
          widths: {
            parent: "col-sm-5",
            children: "col-sm-12"
          },
          placeHolder: "",
          label: "",
          name: "",
          description: ""
        },
        {
          inputType: "displaytext",
          widths: {
            parent: "col-sm-3",
            children: "col-sm-12"
          },
          placeHolder: "",
          label: "Maximum Cash/Day",
          name: "",
          description: ""
        },
        {
          inputType: "text",
          widths: {
            parent: "col-sm-2",
            children: "col-sm-12"
          },
          placeHolder: "",
          label: "",
          name: "maximumcashday",
          description: ""
        },
        {
          inputType: "text",
          widths: {
            parent: "col-sm-2",
            children: "col-sm-12"
          },
          placeHolder: "",
          label: "",
          name: "maximumcashday1",
          description: ""
        },
        {
          inputType: "displaytext",
          widths: {
            parent: "col-sm-5",
            children: "col-sm-12"
          },
          placeHolder: "",
          label: "",
          name: "",
          description: ""
        },
        {
          inputType: "displaytext",
          widths: {
            parent: "col-sm-3",
            children: "col-sm-12"
          },
          placeHolder: "",
          label: "Maximum Cash/Week",
          name: "",
          description: ""
        },
        {
          inputType: "text",
          widths: {
            parent: "col-sm-2",
            children: "col-sm-12"
          },
          placeHolder: "",
          label: "",
          name: "maximumcashweek",
          description: ""
        },
        {
          inputType: "text",
          widths: {
            parent: "col-sm-2",
            children: "col-sm-12"
          },
          placeHolder: "",
          label: "",
          name: "maximumcashweek1",
          description: ""
        },
        {
          inputType: "displaytext",
          widths: {
            parent: "col-sm-5",
            children: "col-sm-12"
          },
          placeHolder: "",
          label: "",
          name: "",
          description: ""
        },
        {
          inputType: "displaytext",
          widths: {
            parent: "col-sm-3",
            children: "col-sm-12"
          },
          placeHolder: "",
          label: "Maximum Cash Without PAN",
          name: "",
          description: ""
        },
        {
          inputType: "text",
          widths: {
            parent: "col-sm-2",
            children: "col-sm-12"
          },
          placeHolder: "",
          label: "",
          name: "maximumcashpan",
          description: ""
        },
        {
          inputType: "text",
          widths: {
            parent: "col-sm-2",
            children: "col-sm-12"
          },
          placeHolder: "",
          label: "",
          name: "maximumcashpan1",
          description: ""
        },
        {
          inputType: "displaytext",
          widths: {
            parent: "col-sm-5",
            children: "col-sm-12"
          },
          placeHolder: "",
          label: "",
          name: "",
          description: ""
        },
        {
          inputType: "displaytext",
          widths: {
            parent: "col-sm-3",
            children: "col-sm-12"
          },
          placeHolder: "",
          label: "Maximum Cash ABB",
          name: "",
          description: ""
        },
        {
          inputType: "text",
          widths: {
            parent: "col-sm-2",
            children: "col-sm-12"
          },
          placeHolder: "",
          label: "",
          name: "maximumcashabb",
          description: ""
        },
        {
          inputType: "text",
          widths: {
            parent: "col-sm-2",
            children: "col-sm-12"
          },
          placeHolder: "",
          label: "",
          name: "maximumcashabb1",
          description: ""
        },
        {
          inputType: "displaytext",
          widths: {
            parent: "col-sm-5",
            children: "col-sm-12"
          },
          placeHolder: "",
          label: "",
          name: "",
          description: ""
        },
        {
          inputType: "displaytext",
          widths: {
            parent: "col-sm-3",
            children: "col-sm-12"
          },
          placeHolder: "",
          label: "Maximum ABB",
          name: "",
          description: ""
        },
        {
          inputType: "text",
          widths: {
            parent: "col-sm-2",
            children: "col-sm-12"
          },
          placeHolder: "",
          label: "",
          name: "maximumabb",
          description: ""
        },
        {
          inputType: "text",
          widths: {
            parent: "col-sm-2",
            children: "col-sm-12"
          },
          placeHolder: "",
          label: "",
          name: "maximumabb1",
          description: ""
        },
        {
          inputType: "displaytext",
          widths: {
            parent: "col-sm-12",
            children: "col-sm-12"
          },
          placeHolder: "",
          label: "Cheque",
          name: "",
          description: ""
        },
        {
          inputType: "checkbox",
          isRequired: true,
          default: "true",
          widths: {
            parent: "col-sm-3",
            children: "col-sm-12"
          },
          placeHolder: "Allow Cheque Book",
          label: "Allow Cheque Book",
          name: "allowcheque",
          description: "Allow Cheque Book"
        },
        {
          inputType: "displaytext",
          widths: {
            parent: "col-sm-3",
            children: "col-sm-12"
          },
          placeHolder: "",
          label: "Minimum Cheque Nos",
          name: "",
          description: ""
        },
        {
          inputType: "text",
          widths: {
            parent: "col-sm-2",
            children: "col-sm-12"
          },
          placeHolder: "",
          label: "",
          name: "chequeno",
          description: ""
        },
        {
          inputType: "displaytext",
          widths: {
            parent: "col-sm-2",
            children: "col-sm-12"
          },
          placeHolder: "",
          label: "Cheque AlphaCode ",
          name: "",
          description: ""
        },
        {
          inputType: "text",
          widths: {
            parent: "col-sm-2",
            children: "col-sm-12"
          },
          placeHolder: "",
          label: "",
          name: "chequecode",
          description: ""
        },
        {
          inputType: "displaytext",
          widths: {
            parent: "col-sm-4",
            children: "col-sm-12"
          },
          placeHolder: "",
          label: "Additional Minimum Balance For Cheque",
          name: "",
          description: ""
        },
        {
          inputType: "text",
          widths: {
            parent: "col-sm-2",
            children: "col-sm-12"
          },
          placeHolder: "",
          label: "",
          name: "chequebalance",
          description: ""
        },
        {
          inputType: "displaytext",
          widths: {
            parent: "col-sm-12",
            children: "col-sm-12"
          },
          placeHolder: "",
          label: "Flexi Deposit",
          name: "",
          description: ""
        },
        {
          inputType: "checkbox",
          isRequired: true,
          default: "true",
          widths: {
            parent: "col-sm-2",
            children: "col-sm-12"
          },
          placeHolder: "Allow Flexi Deposit",
          label: "Allow Flexi Deposit",
          name: "allowflexideposit",
          description: "Allow Flexi Deposit"
        },
        {
          inputType: "displaytext",
          widths: {
            parent: "col-sm-3",
            children: "col-sm-12"
          },
          placeHolder: "",
          label: "Minimum Balance for Flexi Deposit",
          name: "",
          description: ""
        },
        {
          inputType: "text",
          widths: {
            parent: "col-sm-2",
            children: "col-sm-12"
          },
          placeHolder: "",
          label: "",
          name: "minimumflexibalance",
          description: ""
        },
        {
          inputType: "displaytext",
          widths: {
            parent: "col-sm-3",
            children: "col-sm-12"
          },
          placeHolder: "",
          label: "Flexi Deposit in Multiples of",
          name: "",
          description: ""
        },
        {
          inputType: "text",
          widths: {
            parent: "col-sm-2",
            children: "col-sm-12"
          },
          placeHolder: "",
          label: "",
          name: "flexidepositmultiples",
          description: ""
        },
        {
          inputType: "displaytext",
          widths: {
            parent: "col-sm-3",
            children: "col-sm-12"
          },
          placeHolder: "",
          label: "Flexi Product",
          name: "",
          description: ""
        },
        {
          inputType: "text",
          widths: {
            parent: "col-sm-2",
            children: "col-sm-12"
          },
          placeHolder: "",
          label: "",
          name: "Flexi_Product",
          description: ""
        },

      ]
    },


    {
      inputType: "checkbox",
      isRequired: true,
      default: "true",
      tab: "interest",
      widths: {
        parent: "col-sm-6",
        children: "col-sm-12"
      },
      placeHolder: "ATM CARD Allowed",
      label: "ATM CARD Allowed",
      name: "atmcard",
      description: "ATM CARD Allowed"
    },
    {
      inputType: "checkbox",
      isRequired: true,
      default: "true",
      tab: "interest",
      widths: {
        parent: "col-sm-3",
        children: "col-sm-12"
      },
      placeHolder: "input with checkbox",
      label: "Interest On Interest",
      name: "intereston",
      description: "Interest On Interest"
    },
    {
      inputType: "checkbox",
      isRequired: true,
      default: "true",
      tab: "interest",
      widths: {
        parent: "col-sm-3",
        children: "col-sm-12"
      },
      placeHolder: "input with checkbox",
      label: "Include Today for interest calculation",
      name: "includeinterest",
      description: "Include Today for interest calculation"
    },
    {
      inputType: "checkbox",
      isRequired: true,
      default: "true",
      tab: "interest",
      widths: {
        parent: "col-sm-4",
        children: "col-sm-12"
      },
      placeHolder: "input with checkbox",
      label: "Include Opening Date for Interest Calculation",
      name: "includeinterestcal",
      description: "Include Opening Date for Interest Calculation"
    },
    {
      inputType: "displaytext",
      tab: "interest",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "Interest Slab Wise",
      label: "Interest Slab Wise",
      name: "interestslabwise",
      description: "Interest Slab Wise"
    },
    {
      inputType: "autocomplete",
      tab: "interest",
      elementProps: {
        stayOpen: false,
        removeSelected: true,
        disabled: false,
        rtl: false
      },
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      options: [
        {
          label: "Normal",
          value: "Normal"
        },
        {
          label: "Normal",
          value: "Normal"
        }
      ],
      ajaxLoad: true,
      ajaxOptions: {
        query: {
          dialect: "mongodb",
          query: "getTDSflag",
          fieldType: "string",
          filters: ["pageData", "tdsflag"]
        },
        label: "display",
        value: "display"
      },
      placeHolder: "Interest Slab Wise",
      name: "interestslabwise",
      description: "Interest Slab Wise"
    },
    {
      inputType: "displaytext",
      tab: "interest",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "Interest Product Type",
      label: "Interest Product Type",
      name: "interestproduct",
      description: "Interest Product Type"
    },
    {
      inputType: "autocomplete",
      tab: "interest",
      elementProps: {
        stayOpen: false,
        removeSelected: true,
        disabled: false,
        rtl: false
      },
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      options: [
        {
          label: "DailyBalance",
          value: "DailyBalance"
        },
        {
          label: "DailyBalance",
          value: "DailyBalance"
        }
      ],
      ajaxLoad: true,
      ajaxOptions: {
        query: {
          dialect: "mongodb",
          query: "getTDSflag",
          fieldType: "string",
          filters: ["pageData", "tdsflag"]
        },
        label: "display",
        value: "display"
      },
      placeHolder: "Interest Product Type",
      name: "interestproduct",
      description: "Interest Product Type"
    },
    {
      inputType: "displaytext",
      tab: "interest",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "Interest Frequency",
      label: "Interest Frequency",
      name: "interestfrequency",
      description: "Interest Frequency"
    },
    {
      inputType: "autocomplete",
      tab: "interest",
      elementProps: {
        stayOpen: false,
        removeSelected: true,
        disabled: false,
        rtl: false
      },
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      options: [
        {
          label: "monthly",
          value: "monthly"
        },
        {
          label: "Daily",
          value: "Daily"
        }
      ],
      ajaxLoad: true,
      ajaxOptions: {
        query: {
          dialect: "mongodb",
          query: "getTDSflag",
          fieldType: "string",
          filters: ["pageData", "tdsflag"]
        },
        label: "display",
        value: "display"
      },
      placeHolder: "Interest Frequency",
      name: "interestfrequency",
      description: "Interest Frequency"
    },
    {
      inputType: "displaytext",
      tab: "interest",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "Interest Seperate",
      label: "Interest Seperate",
      name: "interestseperate",
      description: "Interest Seperate"
    },
    {
      inputType: "autocomplete",
      tab: "interest",
      elementProps: {
        stayOpen: false,
        removeSelected: true,
        disabled: false,
        rtl: false
      },
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      options: [
        {
          label: "monthly",
          value: "monthly"
        },
        {
          label: "Daily",
          value: "Daily"
        }
      ],
      ajaxLoad: true,
      ajaxOptions: {
        query: {
          dialect: "mongodb",
          query: "getTDSflag",
          fieldType: "string",
          filters: ["pageData", "tdsflag"]
        },
        label: "display",
        value: "display"
      },
      placeHolder: "Interest Seperate",
      name: "interestseperate",
      description: "Interest Seperate"
    },
    {
      inputType: "displaytext",
      tab: "interest",
      widths: {
        parent: "col-sm-4",
        children: "col-sm-12"
      },
      placeHolder: "Standing Interest Calculation Type",
      label: "Standing Interest Calculation Type",
      name: "Standing_Interest",
      description: "Standing Interest"
    },
    {
      inputType: "autocomplete",
      tab: "interest",
      elementProps: {
        stayOpen: false,
        removeSelected: true,
        disabled: false,
        rtl: false
      },
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      options: [
        {
          label: "monthly",
          value: "monthly"
        },
        {
          label: "Daily",
          value: "Daily"
        }
      ],
      ajaxLoad: true,
      ajaxOptions: {
        query: {
          dialect: "mongodb",
          query: "getTDSflag",
          fieldType: "string",
          filters: ["pageData", "tdsflag"]
        },
        label: "display",
        value: "display"
      },
      placeHolder: "Standing Interest Calculation Type",
      name: "Standing_Interest",
      description: "Standing Interest Calculation Type"
    },
    {
      inputType: "displaytext",
      tab: "interest",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "Receivable GL",
      label: "",
      name: "Receivable_GL",
      description: "Receivable GL"
    },
    {
      inputType: "displaytext",
      tab: "interest",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "Receivable GL",
      label: "Receivable GL",
      name: "Receivable_GL",
      description: "Receivable GL"
    },
    {
      inputType: "text",
      tab: "interest",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "Receivable GL",
      name: "Receivable_GL",
      description: "Receivable GL"
    },
    {
      inputType: "displaytext",
      tab: "interest",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "Received GL",
      label: "Received GL",
      name: "Received_GL",
      description: "Received GL"
    },
    {
      inputType: "text",
      tab: "interest",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "Received GL",
      name: "Received_GL",
      description: "Received GL"
    },
    {
      inputType: "displaytext",
      tab: "interest",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "Int Reserve GL",
      label: "Int Reserve GL",
      name: "Reserve_GL",
      description: "Int Reserve GL"
    },
    {
      inputType: "text",
      tab: "interest",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "Int Reserve GL",
      name: "Reserve_GL",
      description: "Int Reserve GL"
    },
    {
      inputType: "displaytext",
      tab: "interest",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "NPA Received GL",
      label: "NPA Received GL",
      name: "Received_NPA",
      description: "Received NPA"
    },
    {
      inputType: "text",
      tab: "interest",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "Received NPA",
      name: "Received_NPA",
      description: "Received NPA"
    },
    {
      inputType: "displaytext",
      tab: "interest",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "Minimum Interest",
      label: "Minimum Interest",
      name: "Minimum_Interest",
      description: "Minimum Interest"
    },
    {
      inputType: "text",
      tab: "interest",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "Minimum Interest",
      name: "Minimum_Interest",
      description: "Minimum Interest"
    },
    {
      inputType: "displaytext",
      tab: "loancolumns",
      widths: {
        parent: "col-sm-4",
        children: "col-sm-12"
      },
      placeHolder: "Receivable GL",
      label: "",
      name: "Receivable_GL",
      description: "Receivable GL"
    },
    {
      inputType: "displaytext",
      tab: "loancolumns",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "Receivable GL",
      label: "Receivable GL",
      name: "Receivable_GL",
      description: "Receivable GL"
    },
    {
      inputType: "displaytext",
      tab: "loancolumns",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "Received GL",
      label: "Received GL",
      name: "Received_GL",
      description: "Received GL"
    },

    {
      inputType: "displaytext",
      tab: "loancolumns",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "Int Reserve GL",
      label: "Reserve GL",
      name: "Reserve_GL",
      description: "Int Reserve GL"
    },
    {
      inputType: "displaytext",
      tab: "loancolumns",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "Receivable GL",
      label: "",
      name: "Receivable_GL",
      description: "Receivable GL"
    },

    {
      inputType: "checkbox",
      isRequired: true,
      default: "true",
      tab: "loancolumns",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "Penal Columns",
      label: "Penal Columns",
      name: "Penal_Columns",
      description: "Penal Columns"
    },
    {
      inputType: "checkbox",
      isRequired: true,
      default: "true",
      tab: "loancolumns",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "Penal Seperate",
      label: "Penal Seperate",
      name: "Penal_Seperate",
      description: "Penal Seperate"
    },
    {
      inputType: "autocomplete",
      tab: "loancolumns",
      elementProps: {
        stayOpen: false,
        removeSelected: true,
        disabled: false,
        rtl: false
      },
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      options: [
        {
          label: "monthly",
          value: "monthly"
        },
        {
          label: "Daily",
          value: "Daily"
        }
      ],
      ajaxLoad: true,
      ajaxOptions: {
        query: {
          dialect: "mongodb",
          query: "getTDSflag",
          fieldType: "string",
          filters: ["pageData", "tdsflag"]
        },
        label: "display",
        value: "display"
      },
      placeHolder: "Receivable GL",
      name: "Receivable_GL",
      description: "Receivable GL"
    },
    {
      inputType: "autocomplete",
      tab: "loancolumns",
      elementProps: {
        stayOpen: false,
        removeSelected: true,
        disabled: false,
        rtl: false
      },
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      options: [
        {
          label: "monthly",
          value: "monthly"
        },
        {
          label: "Daily",
          value: "Daily"
        }
      ],
      ajaxLoad: true,
      ajaxOptions: {
        query: {
          dialect: "mongodb",
          query: "getTDSflag",
          fieldType: "string",
          filters: ["pageData", "tdsflag"]
        },
        label: "display",
        value: "display"
      },
      placeHolder: "Received GL",
      name: "Received_GL",
      description: "Received GL"
    },
    {
      inputType: "autocomplete",
      tab: "loancolumns",
      elementProps: {
        stayOpen: false,
        removeSelected: true,
        disabled: false,
        rtl: false
      },
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      options: [
        {
          label: "monthly",
          value: "monthly"
        },
        {
          label: "Daily",
          value: "Daily"
        }
      ],
      ajaxLoad: true,
      ajaxOptions: {
        query: {
          dialect: "mongodb",
          query: "getTDSflag",
          fieldType: "string",
          filters: ["pageData", "tdsflag"]
        },
        label: "display",
        value: "display"
      },
      placeHolder: "Int Reserve GL",
      name: "Reserve_GL",
      description: "Int Reserve GL"
    },
    {
      inputType: "displaytext",
      tab: "loancolumns",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "Minimum Interest",
      label: "",
      name: "Minimum_Interest",
      description: "Minimum Interest"
    },
    {
      inputType: "checkbox",
      isRequired: true,
      default: "true",
      tab: "loancolumns",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "Postage Columns",
      label: "Postage Columns",
      name: "Postage_Columns",
      description: "Postage Columns"
    },
    {
      inputType: "checkbox",
      isRequired: true,
      default: "true",
      tab: "loancolumns",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "Postage Seperate",
      label: "Postage Seperate",
      name: "Postage_Seperate",
      description: "Postage Seperate"
    },
    {
      inputType: "autocomplete",
      tab: "loancolumns",
      elementProps: {
        stayOpen: false,
        removeSelected: true,
        disabled: false,
        rtl: false
      },
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      options: [
        {
          label: "monthly",
          value: "monthly"
        },
        {
          label: "Daily",
          value: "Daily"
        }
      ],
      ajaxLoad: true,
      ajaxOptions: {
        query: {
          dialect: "mongodb",
          query: "getTDSflag",
          fieldType: "string",
          filters: ["pageData", "tdsflag"]
        },
        label: "display",
        value: "display"
      },
      placeHolder: "Receivable GL",
      name: "Receivable_GL1",
      description: "Receivable GL"
    },
    {
      inputType: "autocomplete",
      tab: "loancolumns",
      elementProps: {
        stayOpen: false,
        removeSelected: true,
        disabled: false,
        rtl: false
      },
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      options: [
        {
          label: "monthly",
          value: "monthly"
        },
        {
          label: "Daily",
          value: "Daily"
        }
      ],
      ajaxLoad: true,
      ajaxOptions: {
        query: {
          dialect: "mongodb",
          query: "getTDSflag",
          fieldType: "string",
          filters: ["pageData", "tdsflag"]
        },
        label: "display",
        value: "display"
      },
      placeHolder: "Received GL",
      name: "Received_GL1",
      description: "Received GL"
    },
    {
      inputType: "autocomplete",
      tab: "loancolumns",
      elementProps: {
        stayOpen: false,
        removeSelected: true,
        disabled: false,
        rtl: false
      },
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      options: [
        {
          label: "monthly",
          value: "monthly"
        },
        {
          label: "Daily",
          value: "Daily"
        }
      ],
      ajaxLoad: true,
      ajaxOptions: {
        query: {
          dialect: "mongodb",
          query: "getTDSflag",
          fieldType: "string",
          filters: ["pageData", "tdsflag"]
        },
        label: "display",
        value: "display"
      },
      placeHolder: "Int Reserve GL",
      name: "Reserve_GL1",
      description: "Int Reserve GL"
    },
    {
      inputType: "displaytext",
      tab: "loancolumns",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "Minimum Interest",
      label: "",
      name: "Minimum_Interest",
      description: "Minimum Interest"
    },
    {
      inputType: "checkbox",
      isRequired: true,
      default: "true",
      tab: "loancolumns",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "Notice fees Columns",
      label: "Notice fees Columns",
      name: "Notice_Columns",
      description: "Postage Columns"
    },
    {
      inputType: "checkbox",
      isRequired: true,
      default: "true",
      tab: "loancolumns",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "Notice fees Seperate",
      label: "Notice fees Seperate",
      name: "Noticefees",
      description: "Notice fees Seperate"
    },
    {
      inputType: "autocomplete",
      tab: "loancolumns",
      elementProps: {
        stayOpen: false,
        removeSelected: true,
        disabled: false,
        rtl: false
      },
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      options: [
        {
          label: "monthly",
          value: "monthly"
        },
        {
          label: "Daily",
          value: "Daily"
        }
      ],
      ajaxLoad: true,
      ajaxOptions: {
        query: {
          dialect: "mongodb",
          query: "getTDSflag",
          fieldType: "string",
          filters: ["pageData", "tdsflag"]
        },
        label: "display",
        value: "display"
      },
      placeHolder: "Receivable GL",
      name: "Receivable_GL2",
      description: "Receivable GL"
    },
    {
      inputType: "autocomplete",
      tab: "loancolumns",
      elementProps: {
        stayOpen: false,
        removeSelected: true,
        disabled: false,
        rtl: false
      },
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      options: [
        {
          label: "monthly",
          value: "monthly"
        },
        {
          label: "Daily",
          value: "Daily"
        }
      ],
      ajaxLoad: true,
      ajaxOptions: {
        query: {
          dialect: "mongodb",
          query: "getTDSflag",
          fieldType: "string",
          filters: ["pageData", "tdsflag"]
        },
        label: "display",
        value: "display"
      },
      placeHolder: "Received GL",
      name: "Received_GL2",
      description: "Received GL"
    },
    {
      inputType: "autocomplete",
      tab: "loancolumns",
      elementProps: {
        stayOpen: false,
        removeSelected: true,
        disabled: false,
        rtl: false
      },
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      options: [
        {
          label: "monthly",
          value: "monthly"
        },
        {
          label: "Daily",
          value: "Daily"
        }
      ],
      ajaxLoad: true,
      ajaxOptions: {
        query: {
          dialect: "mongodb",
          query: "getTDSflag",
          fieldType: "string",
          filters: ["pageData", "tdsflag"]
        },
        label: "display",
        value: "display"
      },
      placeHolder: "Int Reserve GL",
      name: "Reserve_GL2",
      description: "Int Reserve GL"
    },
    {
      inputType: "displaytext",
      tab: "loancolumns",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "Minimum Interest",
      label: "",
      name: "Minimum_Interest",
      description: "Minimum Interest"
    },
    {
      inputType: "checkbox",
      isRequired: true,
      default: "true",
      tab: "loancolumns",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "Court Exps Columns",
      label: "Court Exps Columns",
      name: "Court_Columns",
      description: "Court Exps Columns"
    },
    {
      inputType: "checkbox",
      isRequired: true,
      default: "true",
      tab: "loancolumns",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "Court Exps Seperate",
      label: "Court Exps Seperate",
      name: "court",
      description: "Court Exps Seperate"
    },
    {
      inputType: "autocomplete",
      tab: "loancolumns",
      elementProps: {
        stayOpen: false,
        removeSelected: true,
        disabled: false,
        rtl: false
      },
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      options: [
        {
          label: "monthly",
          value: "monthly"
        },
        {
          label: "Daily",
          value: "Daily"
        }
      ],
      ajaxLoad: true,
      ajaxOptions: {
        query: {
          dialect: "mongodb",
          query: "getTDSflag",
          fieldType: "string",
          filters: ["pageData", "tdsflag"]
        },
        label: "display",
        value: "display"
      },
      placeHolder: "Receivable GL",
      name: "Receivable_GL3",
      description: "Receivable GL"
    },
    {
      inputType: "autocomplete",
      tab: "loancolumns",
      elementProps: {
        stayOpen: false,
        removeSelected: true,
        disabled: false,
        rtl: false
      },
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      options: [
        {
          label: "monthly",
          value: "monthly"
        },
        {
          label: "Daily",
          value: "Daily"
        }
      ],
      ajaxLoad: true,
      ajaxOptions: {
        query: {
          dialect: "mongodb",
          query: "getTDSflag",
          fieldType: "string",
          filters: ["pageData", "tdsflag"]
        },
        label: "display",
        value: "display"
      },
      placeHolder: "Received GL",
      name: "Received_GL3",
      description: "Received GL"
    },
    {
      inputType: "autocomplete",
      tab: "loancolumns",
      elementProps: {
        stayOpen: false,
        removeSelected: true,
        disabled: false,
        rtl: false
      },
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      options: [
        {
          label: "monthly",
          value: "monthly"
        },
        {
          label: "Daily",
          value: "Daily"
        }
      ],
      ajaxLoad: true,
      ajaxOptions: {
        query: {
          dialect: "mongodb",
          query: "getTDSflag",
          fieldType: "string",
          filters: ["pageData", "tdsflag"]
        },
        label: "display",
        value: "display"
      },
      placeHolder: "Int Reserve GL",
      name: "Reserve_GL3",
      description: "Int Reserve GL"
    },
    {
      inputType: "displaytext",
      tab: "loancolumns",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "Minimum Interest",
      label: "",
      name: "Minimum_Interest",
      description: "Minimum Interest"
    },
    {
      inputType: "checkbox",
      isRequired: true,
      default: "true",
      tab: "loancolumns",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "Insurance Columns",
      label: "Insurance Columns",
      name: "Insurance_Columns",
      description: "Insurance Columns"
    },
    {
      inputType: "checkbox",
      isRequired: true,
      default: "true",
      tab: "loancolumns",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "Insurance Seperate",
      label: "Insurance Seperate",
      name: "Insurance",
      description: "Insurance Seperate"
    },
    {
      inputType: "autocomplete",
      tab: "loancolumns",
      elementProps: {
        stayOpen: false,
        removeSelected: true,
        disabled: false,
        rtl: false
      },
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      options: [
        {
          label: "monthly",
          value: "monthly"
        },
        {
          label: "Daily",
          value: "Daily"
        }
      ],
      ajaxLoad: true,
      ajaxOptions: {
        query: {
          dialect: "mongodb",
          query: "getTDSflag",
          fieldType: "string",
          filters: ["pageData", "tdsflag"]
        },
        label: "display",
        value: "display"
      },
      placeHolder: "Receivable GL",
      name: "Receivable_GL4",
      description: "Receivable GL"
    },
    {
      inputType: "autocomplete",
      tab: "loancolumns",
      elementProps: {
        stayOpen: false,
        removeSelected: true,
        disabled: false,
        rtl: false
      },
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      options: [
        {
          label: "monthly",
          value: "monthly"
        },
        {
          label: "Daily",
          value: "Daily"
        }
      ],
      ajaxLoad: true,
      ajaxOptions: {
        query: {
          dialect: "mongodb",
          query: "getTDSflag",
          fieldType: "string",
          filters: ["pageData", "tdsflag"]
        },
        label: "display",
        value: "display"
      },
      placeHolder: "Received GL",
      name: "Received_GL4",
      description: "Received GL"
    },
    {
      inputType: "autocomplete",
      tab: "loancolumns",
      elementProps: {
        stayOpen: false,
        removeSelected: true,
        disabled: false,
        rtl: false
      },
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      options: [
        {
          label: "monthly",
          value: "monthly"
        },
        {
          label: "Daily",
          value: "Daily"
        }
      ],
      ajaxLoad: true,
      ajaxOptions: {
        query: {
          dialect: "mongodb",
          query: "getTDSflag",
          fieldType: "string",
          filters: ["pageData", "tdsflag"]
        },
        label: "display",
        value: "display"
      },
      placeHolder: "Int Reserve GL",
      name: "Reserve_GL4",
      description: "Int Reserve GL"
    },
    {
      inputType: "displaytext",
      tab: "loancolumns",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "Minimum Interest",
      label: "",
      name: "Minimum_Interest",
      description: "Minimum Interest"
    },
    {
      inputType: "checkbox",
      isRequired: true,
      default: "true",
      tab: "loancolumns",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "Surcharge Columns",
      label: "Surcharge Columns",
      name: "Surcharge_Columns",
      description: "Surcharge Columns"
    },
    {
      inputType: "checkbox",
      isRequired: true,
      default: "true",
      tab: "loancolumns",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "Surcharge Seperate",
      label: "Surcharge Seperate",
      name: "Surcharge",
      description: "Surcharge Seperate"
    },
    {
      inputType: "autocomplete",
      tab: "loancolumns",
      elementProps: {
        stayOpen: false,
        removeSelected: true,
        disabled: false,
        rtl: false
      },
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      options: [
        {
          label: "monthly",
          value: "monthly"
        },
        {
          label: "Daily",
          value: "Daily"
        }
      ],
      ajaxLoad: true,
      ajaxOptions: {
        query: {
          dialect: "mongodb",
          query: "getTDSflag",
          fieldType: "string",
          filters: ["pageData", "tdsflag"]
        },
        label: "display",
        value: "display"
      },
      placeHolder: "Receivable GL",
      name: "Receivable_GL5",
      description: "Receivable GL"
    },
    {
      inputType: "autocomplete",
      tab: "loancolumns",
      elementProps: {
        stayOpen: false,
        removeSelected: true,
        disabled: false,
        rtl: false
      },
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      options: [
        {
          label: "monthly",
          value: "monthly"
        },
        {
          label: "Daily",
          value: "Daily"
        }
      ],
      ajaxLoad: true,
      ajaxOptions: {
        query: {
          dialect: "mongodb",
          query: "getTDSflag",
          fieldType: "string",
          filters: ["pageData", "tdsflag"]
        },
        label: "display",
        value: "display"
      },
      placeHolder: "Received GL",
      name: "Received_GL5",
      description: "Received GL"
    },
    {
      inputType: "autocomplete",
      tab: "loancolumns",
      elementProps: {
        stayOpen: false,
        removeSelected: true,
        disabled: false,
        rtl: false
      },
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      options: [
        {
          label: "monthly",
          value: "monthly"
        },
        {
          label: "Daily",
          value: "Daily"
        }
      ],
      ajaxLoad: true,
      ajaxOptions: {
        query: {
          dialect: "mongodb",
          query: "getTDSflag",
          fieldType: "string",
          filters: ["pageData", "tdsflag"]
        },
        label: "display",
        value: "display"
      },
      placeHolder: "Int Reserve GL",
      name: "Reserve_GL5",
      description: "Int Reserve GL"
    },
    {
      inputType: "displaytext",
      tab: "loancolumns",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "Minimum Interest",
      label: "",
      name: "Minimum_Interest",
      description: "Minimum Interest"
    },
    {
      inputType: "checkbox",
      isRequired: true,
      default: "true",
      tab: "loancolumns",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "Other Exp Columns",
      label: "Other Exp Columns",
      name: "Other_Columns",
      description: "Other Exp Columns"
    },
    {
      inputType: "checkbox",
      isRequired: true,
      default: "true",
      tab: "loancolumns",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "Other Exp Seperate",
      label: "Other Exp Seperate",
      name: "OtherExp",
      description: "Other Exp Seperate"
    },
    {
      inputType: "autocomplete",
      tab: "loancolumns",
      elementProps: {
        stayOpen: false,
        removeSelected: true,
        disabled: false,
        rtl: false
      },
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      options: [
        {
          label: "monthly",
          value: "monthly"
        },
        {
          label: "Daily",
          value: "Daily"
        }
      ],
      ajaxLoad: true,
      ajaxOptions: {
        query: {
          dialect: "mongodb",
          query: "getTDSflag",
          fieldType: "string",
          filters: ["pageData", "tdsflag"]
        },
        label: "display",
        value: "display"
      },
      placeHolder: "Receivable GL",
      name: "Receivable_GL6",
      description: "Receivable GL"
    },
    {
      inputType: "autocomplete",
      tab: "loancolumns",
      elementProps: {
        stayOpen: false,
        removeSelected: true,
        disabled: false,
        rtl: false
      },
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      options: [
        {
          label: "monthly",
          value: "monthly"
        },
        {
          label: "Daily",
          value: "Daily"
        }
      ],
      ajaxLoad: true,
      ajaxOptions: {
        query: {
          dialect: "mongodb",
          query: "getTDSflag",
          fieldType: "string",
          filters: ["pageData", "tdsflag"]
        },
        label: "display",
        value: "display"
      },
      placeHolder: "Received GL",
      name: "Received_GL6",
      description: "Received GL"
    },
    {
      inputType: "autocomplete",
      tab: "loancolumns",
      elementProps: {
        stayOpen: false,
        removeSelected: true,
        disabled: false,
        rtl: false
      },
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      options: [
        {
          label: "monthly",
          value: "monthly"
        },
        {
          label: "Daily",
          value: "Daily"
        }
      ],
      ajaxLoad: true,
      ajaxOptions: {
        query: {
          dialect: "mongodb",
          query: "getTDSflag",
          fieldType: "string",
          filters: ["pageData", "tdsflag"]
        },
        label: "display",
        value: "display"
      },
      placeHolder: "Int Reserve GL",
      name: "Reserve_GL6",
      description: "Int Reserve GL"
    },
    {
      inputType: "checkbox",
      isRequired: true,
      default: "true",
      tab: "smsparameter",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "input with checkbox",
      label: "Send SMS After Maturity",
      name: "sendsms",
      description: "Active"
    },
    {
        inputType: "checkbox",
        isRequired: true,
        default: "true",
        tab: "smsparameter",
        widths: {
          parent: "col-sm-2",
          children: "col-sm-12"
        },
        placeHolder: "input with checkbox",
        label: "SMS Chargeable",
        name: "Chargeablesms",
        description: "Active"
      },
      {
        inputType: "checkbox",
        isRequired: true,
        default: "true",
        tab: "smsparameter",
        widths: {
          parent: "col-sm-2",
          children: "col-sm-12"
        },
        placeHolder: "input with checkbox",
        label: "Send SMS at Month End",
        name: "Sendsmsend",
        description: "Active"
      },
      {
        inputType: "checkbox",
        isRequired: true,
        default: "true",
        tab: "smsparameter",
        widths: {
          parent: "col-sm-2",
          children: "col-sm-12"
        },
        placeHolder: "input with checkbox",
        label: "Send Transactions SMS",
        name: "Sendstransaction",
        description: "Active"
      },
      {
        inputType: "displaytext",
        tab: "smsparameter",
        widths: {
          parent: "col-sm-2",
          children: "col-sm-12"
        },
        placeHolder: "Above Amount",
        label: "Above Amount",
        name: "aboveamt",
        description: "Above Amount"
      },
      {
        inputType: "text",
        tab: "smsparameter",
        widths: {
          parent: "col-sm-2",
          children: "col-sm-12"
        },
        placeHolder: "Above Amount",
        label: "",
        name: "aboveamt",
        description: "Above Amount"
      },
      {
        inputType: "displaytext",
        tab: "smsparameter",
        widths: {
          parent: "col-sm-2",
          children: "col-sm-12"
        },
        placeHolder: "SMS Before Days",
        label: "SMS Before Days",
        name: "SMSBefore",
        description: "SMS Before Days"
      },
      {
        inputType: "text",
        tab: "smsparameter",
        widths: {
          parent: "col-sm-2",
          children: "col-sm-12"
        },
        placeHolder: "SMS Before Days",
        label: "",
        name: "SMSBefore",
        description: "SMS Before Days"
      },
      {
        inputType: "displaytext",
        tab: "smsparameter",
        widths: {
          parent: "col-sm-2",
          children: "col-sm-12"
        },
        placeHolder: "SMS Before Days",
        label: "SMS After Days",
        name: "SMSAfter",
        description: "SMS After Days"
      },
      {
        inputType: "text",
        tab: "smsparameter",
        widths: {
          parent: "col-sm-2",
          children: "col-sm-12"
        },
        placeHolder: "SMS After Days",
        label: "",
        name: "SMSAfter",
        description: "SMS After Days"
      },
      {
        inputType: "displaytext",
        tab: "smsparameter",
        widths: {
          parent: "col-sm-2",
          children: "col-sm-12"
        },
        placeHolder: "SMS Repeate for Days",
        label: "SMS Repeate for Days",
        name: "SMSRepeate",
        description: "SMS Repeate for Days"
      },
      {
        inputType: "text",
        tab: "smsparameter",
        widths: {
          parent: "col-sm-2",
          children: "col-sm-12"
        },
        placeHolder: "SMS Repeate for Days",
        label: "",
        name: "SMSRepeate",
        description: "SMS Repeate for Days"
      },
      {
        inputType: "checkbox",
        isRequired: true,
        default: "true",
        tab: "smsparameter",
        widths: {
          parent: "col-sm-2",
          children: "col-sm-12"
        },
        placeHolder: "input with checkbox",
        label: "SMS Chargeable",
        name: "SMS_Chargeable",
        description: "Active"
      },
      {
        inputType: "checkbox",
        isRequired: true,
        default: "true",
        tab: "smsparameter",
        widths: {
          parent: "col-sm-2",
          children: "col-sm-12"
        },
        placeHolder: "input with checkbox",
        label: "Interest SMS",
        name: "Interest_SMS",
        description: "Active"
      },
      {
        inputType: "checkbox",
        isRequired: true,
        default: "true",
        tab: "smsparameter",
        widths: {
          parent: "col-sm-3",
          children: "col-sm-12"
        },
        placeHolder: "input with checkbox",
        label: "Send SMS For A/C Opening",
        name: "Send_SMS",
        description: "Active"
      },
      {
        inputType: "checkbox",
        isRequired: true,
        default: "true",
        tab: "smsparameter",
        widths: {
          parent: "col-sm-3",
          children: "col-sm-12"
        },
        placeHolder: "input with checkbox",
        label: "A/C Open SMS for Chargeable",
        name: "A/C_Open",
        description: "Active"
      },
      {
        inputType: "displaytext",
        tab: "smsparameter",
        widths: {
          parent: "col-sm-2",
          children: "col-sm-12"
        },
        placeHolder: "",
        label: "",
        name: "",
        description: ""
      },
      {
        inputType: "checkbox",
        isRequired: true,
        default: "true",
        tab: "smsparameter",
        widths: {
          parent: "col-sm-12",
          children: "col-sm-12"
        },
        placeHolder: "input with checkbox",
        label: "Send SMS For Installment",
        name: "SMS_Installment",
        description: "Active"
      },
      {
        inputType: "displaytext",
        tab: "smsparameter",
        widths: {
          parent: "col-sm-1",
          children: "col-sm-12"
        },
        placeHolder: "",
        label: "",
        name: "",
        description: ""
      },
      {
        inputType: "checkbox",
        isRequired: true,
        default: "true",
        tab: "smsparameter",
        widths: {
          parent: "col-sm-11",
          children: "col-sm-12"
        },
        placeHolder: "input with checkbox",
        label: "SMS Chargeable",
        name: "Chargeablesms1",
        description: "Active"
      },
      {
        inputType: "displaytext",
        tab: "smsparameter",
        widths: {
          parent: "col-sm-1",
          children: "col-sm-12"
        },
        placeHolder: "",
        label: "",
        name: "",
        description: ""
      },
      {
        inputType: "checkbox",
        isRequired: true,
        default: "true",
        tab: "smsparameter",
        widths: {
          parent: "col-sm-11",
          children: "col-sm-12"
        },
        placeHolder: "input with checkbox",
        label: "Send SMS at Month End",
        name: "Sendsmsend1",
        description: "Active"
      },
      {
        inputType: "displaytext",
        tab: "smsparameter",
        widths: {
          parent: "col-sm-2",
          children: "col-sm-12"
        },
        placeHolder: "SMS Before Days",
        label: "SMS Before Days",
        name: "SMSBefore2",
        description: "SMS Before Days"
      },
      {
        inputType: "text",
        tab: "smsparameter",
        widths: {
          parent: "col-sm-2",
          children: "col-sm-12"
        },
        placeHolder: "SMS Before Days",
        label: "",
        name: "SMSBefore2",
        description: "SMS Before Days"
      },
      {
        inputType: "displaytext",
        tab: "smsparameter",
        widths: {
          parent: "col-sm-2",
          children: "col-sm-12"
        },
        placeHolder: "SMS Before Days",
        label: "SMS After Days",
        name: "SMSAfter2",
        description: "SMS After Days"
      },
      {
        inputType: "text",
        tab: "smsparameter",
        widths: {
          parent: "col-sm-2",
          children: "col-sm-12"
        },
        placeHolder: "SMS After Days",
        label: "",
        name: "SMSAfter2",
        description: "SMS After Days"
      },
      {
        inputType: "displaytext",
        tab: "smsparameter",
        widths: {
          parent: "col-sm-2",
          children: "col-sm-12"
        },
        placeHolder: "SMS Repeate for Days",
        label: "SMS Repeate for Days",
        name: "SMSRepeate2",
        description: "SMS Repeate for Days"
      },
      {
        inputType: "text",
        tab: "smsparameter",
        widths: {
          parent: "col-sm-2",
          children: "col-sm-12"
        },
        placeHolder: "SMS Repeate for Days",
        label: "",
        name: "SMSRepeate2",
        description: "SMS Repeate for Days"
      },
      {
        inputType: "checkbox",
        isRequired: true,
        default: "true",
        tab: "smsparameter",
        widths: {
          parent: "col-sm-12",
          children: "col-sm-12"
        },
        placeHolder: "input with checkbox",
        label: "Send SMS For Overdue",
        name: "SMS_Overdue",
        description: "Active"
      },
      {
        inputType: "displaytext",
        tab: "smsparameter",
        widths: {
          parent: "col-sm-1",
          children: "col-sm-12"
        },
        placeHolder: "",
        label: "",
        name: "",
        description: ""
      },
      {
        inputType: "checkbox",
        isRequired: true,
        default: "true",
        tab: "smsparameter",
        widths: {
          parent: "col-sm-11",
          children: "col-sm-12"
        },
        placeHolder: "input with checkbox",
        label: "SMS Chargeable",
        name: "Chargeablesms2",
        description: "Active"
      },
      {
        inputType: "displaytext",
        tab: "smsparameter",
        widths: {
          parent: "col-sm-1",
          children: "col-sm-12"
        },
        placeHolder: "",
        label: "",
        name: "",
        description: ""
      },
      {
        inputType: "checkbox",
        isRequired: true,
        default: "true",
        tab: "smsparameter",
        widths: {
          parent: "col-sm-11",
          children: "col-sm-12"
        },
        placeHolder: "input with checkbox",
        label: "Send SMS at Month End",
        name: "Sendsmsend2",
        description: "Active"
      },
      {
        inputType: "displaytext",
        tab: "smsparameter",
        widths: {
          parent: "col-sm-2",
          children: "col-sm-12"
        },
        placeHolder: "SMS Before Days",
        label: "SMS Before Days",
        name: "SMSBefore1",
        description: "SMS Before Days"
      },
      {
        inputType: "text",
        tab: "smsparameter",
        widths: {
          parent: "col-sm-2",
          children: "col-sm-12"
        },
        placeHolder: "SMS Before Days",
        label: "",
        name: "SMSBefore1",
        description: "SMS Before Days"
      },
      {
        inputType: "displaytext",
        tab: "smsparameter",
        widths: {
          parent: "col-sm-2",
          children: "col-sm-12"
        },
        placeHolder: "SMS Before Days",
        label: "SMS After Days",
        name: "SMSAfter1",
        description: "SMS After Days"
      },
      {
        inputType: "text",
        tab: "smsparameter",
        widths: {
          parent: "col-sm-2",
          children: "col-sm-12"
        },
        placeHolder: "SMS After Days",
        label: "",
        name: "SMSAfter1",
        description: "SMS After Days"
      },
      {
        inputType: "displaytext",
        tab: "smsparameter",
        widths: {
          parent: "col-sm-2",
          children: "col-sm-12"
        },
        placeHolder: "SMS Repeate for Days",
        label: "SMS Repeate for Days",
        name: "SMSRepeate1",
        description: "SMS Repeate for Days"
      },
      {
        inputType: "text",
        tab: "smsparameter",
        widths: {
          parent: "col-sm-2",
          children: "col-sm-12"
        },
        placeHolder: "SMS Repeate for Days",
        label: "",
        name: "SMSRepeate1",
        description: "SMS Repeate for Days"
      },
      {
        inputType: "displaytext",
        tab: "smsparameter",
        widths: {
          parent: "col-sm-2",
          children: "col-sm-12"
        },
        placeHolder: "SMS After No Installment",
        label: "SMS After No Installment",
        name: "SMSNoinstallment",
        description: "SMS After No Installment"
      },
      {
        inputType: "text",
        tab: "smsparameter",
        widths: {
          parent: "col-sm-2",
          children: "col-sm-12"
        },
        placeHolder: "After No Installment",
        label: "",
        name: "SMSNoinstallment",
        description: "SMS After No Installment"
      },
      {
        widths: "col-sm-12",
        tab: "loan",
        subComponents: [
          {
            inputType: "displaytext",
            widths: {
              parent: "col-sm-3",
              children: "col-sm-12"
            },
            placeHolder: "Od-Interest Rate",
            label: "Od-Interest Rate",
            name: "Od_Interest",
            description: "Od-Interest Rate"
          },
          {
            inputType: "text",
            widths: {
              parent: "col-sm-3",
              children: "col-sm-12"
            },
            placeHolder: "Od-Interest Rate",
            label: "",
            name: "Od_Interest",
            description: "Od-Interest Rate"
          },
          // {
          //   inputType: "displaytext",
          //   widths: {
          //     parent: "col-sm-3",
          //     children: "col-sm-12"
          //   },
          //   placeHolder: "",
          //   label: "",
          //   name: "",
          //   description: ""
          // },
          {
            inputType: "displaytext",
            widths: {
              parent: "col-sm-3",
              children: "col-sm-12"
            },
            placeHolder: "Minimum days for closing",
            label: "Minimum days for closing",
            name: "Minimumdays",
            description: "Minimum days for closing"
          },
          {
            inputType: "text",
            widths: {
              parent: "col-sm-3",
              children: "col-sm-12"
            },
            placeHolder: "Minimum days for closing",
            label: "",
            name: "Minimumdays",
            description: "Minimum days for closing"
          },
          
          {
            inputType: "displaytext",
            widths: {
              parent: "col-sm-3",
              children: "col-sm-12"
            },
            placeHolder: "Maximum Saction Limit",
            label: "Maximum Saction Limit",
            name: "Maximum_Saction",
            description: "Maximum Saction Limit"
          },
          {
            inputType: "text",
            widths: {
              parent: "col-sm-3",
              children: "col-sm-12"
            },
            placeHolder: "Maximum Saction Limit",
            label: "",
            name: "Maximum_Saction",
            description: "Maximum Saction Limit"
          },
          
          {
            inputType: "displaytext",
            widths: {
              parent: "col-sm-3",
              children: "col-sm-12"
            },
            placeHolder: "Period months for Loan",
            label: "Period months for Loan",
            name: "Periodmonths",
            description: "Period months for Loan"
          },
          {
            inputType: "text",
            widths: {
              parent: "col-sm-3",
              children: "col-sm-12"
            },
            placeHolder: "Period months for Loan",
            label: "",
            name: "Periodmonths",
            description: "Period months for Loan"
          },
          {
            inputType: "displaytext",
            widths: {
              parent: "col-sm-3",
              children: "col-sm-12"
            },
            placeHolder: "Discount Rate",
            label: "Discount Rate",
            name: "Discount_Rate",
            description: "Discount Rate"
          },
          {
            inputType: "text",
            widths: {
              parent: "col-sm-3",
              children: "col-sm-12"
            },
            placeHolder: "Discount Rate",
            label: "",
            name: "Discount_Rate",
            description: "Discount Rate"
          },
          {
            inputType: "displaytext",
            widths: {
              parent: "col-sm-3",
              children: "col-sm-12"
            },
            placeHolder: "Discount For",
            label: "Discount For",
            name: "Discount_For",
            description: "Discount For"
          },
          {
            inputType: "text",
            widths: {
              parent: "col-sm-3",
              children: "col-sm-12"
            },
            placeHolder: "Discount For",
            label: "",
            name: "Discount_For",
            description: "Discount For"
          },
          {
            inputType: "displaytext",
            widths: {
              parent: "col-sm-3",
              children: "col-sm-12"
            },
            placeHolder: "Security",
            label: "Security",
            name: "Security",
            description: "Security"
          },
          {
            inputType: "text",
            widths: {
              parent: "col-sm-3",
              children: "col-sm-12"
            },
            placeHolder: "Security",
            label: "",
            name: "Security",
            description: "Security"
          },
          {
            inputType: "displaytext",
            widths: {
              parent: "col-sm-3",
              children: "col-sm-12"
            },
            placeHolder: "Priority Sector",
            label: "Priority Sector",
            name: "Priority_Sector",
            description: "Priority Sector"
          },
          {
            inputType: "text",
            widths: {
              parent: "col-sm-3",
              children: "col-sm-12"
            },
            placeHolder: "Priority Sector",
            label: "",
            name: "Priority_Sector",
            description: "Priority Sector"
          },
          {
            inputType: "displaytext",
            widths: {
              parent: "col-sm-3",
              children: "col-sm-12"
            },
            placeHolder: "Priority Segment",
            label: "Priority Segment",
            name: "Priority_Segment",
            description: "Priority Segment"
          },
          {
            inputType: "text",
            widths: {
              parent: "col-sm-3",
              children: "col-sm-12"
            },
            placeHolder: "Priority Segment",
            label: "",
            name: "Priority_Segment",
            description: "Priority Segment"
          },
          {
            inputType: "displaytext",
            widths: {
              parent: "col-sm-3",
              children: "col-sm-12"
            },
            placeHolder: "Purpose",
            label: "Purpose",
            name: "Purpose",
            description: "Purpose"
          },
          {
            inputType: "text",
            widths: {
              parent: "col-sm-3",
              children: "col-sm-12"
            },
            placeHolder: "Purpose",
            label: "",
            name: "Purpose",
            description: "Purpose"
          },
          {
            inputType: "displaytext",
            widths: {
              parent: "col-sm-3",
              children: "col-sm-12"
            },
            placeHolder: "Loan Action",
            label: "Loan Action",
            name: "Loan_Action",
            description: "Loan Action"
          },
          {
            inputType: "text",
            widths: {
              parent: "col-sm-3",
              children: "col-sm-12"
            },
            placeHolder: "Loan Action",
            label: "",
            name: "Loan_Action",
            description: "Loan Action"
          },
          {
            inputType: "displaytext",
            widths: {
              parent: "col-sm-3",
              children: "col-sm-12"
            },
            placeHolder: "Saction By",
            label: "Saction By",
            name: "Saction_By",
            description: "Saction By"
          },
          {
            inputType: "text",
            widths: {
              parent: "col-sm-3",
              children: "col-sm-12"
            },
            placeHolder: "Saction By",
            label: "",
            name: "Saction_By",
            description: "Saction By"
          },
          {
            inputType: "displaytext",
            widths: {
              parent: "col-sm-3",
              children: "col-sm-12"
            },
            placeHolder: "Referenced By",
            label: "Referenced By",
            name: "Referenced_By",
            description: "Referenced By"
          },
          {
            inputType: "text",
            widths: {
              parent: "col-sm-3",
              children: "col-sm-12"
            },
            placeHolder: "Referenced By",
            label: "",
            name: "Referenced_By",
            description: "Referenced By"
          },
          {
            inputType: "displaytext",
            widths: {
              parent: "col-sm-3",
              children: "col-sm-12"
            },
            placeHolder: "Industry By",
            label: "Industry By",
            name: "Industry_By",
            description: "Industry By"
          },
          {
            inputType: "text",
            widths: {
              parent: "col-sm-3",
              children: "col-sm-12"
            },
            placeHolder: "Industry By",
            label: "",
            name: "Industry_By",
            description: "Industry By"
          },
        ]
      },
      
      {
        widths: "col-sm-12",
        tab: "loan",
        subComponents: [
          {
            inputType: "checkbox",
            isRequired: true,
            default: "true",
            widths: {
              parent: "col-sm-6",
              children: "col-sm-12"
            },
            placeHolder: "input with checkbox",
            label: "Agriculture Loan",
            name: "Agriculture_Loan",
            description: "Active"
          },
          {
            inputType: "checkbox",
            isRequired: true,
            default: "true",
            widths: {
              parent: "col-sm-6",
              children: "col-sm-12"
            },
            placeHolder: "input with checkbox",
            label: "want Credit Balance Seperate",
            name: "Credit_Balance",
            description: "Active"
          },
          {
            inputType: "checkbox",
            isRequired: true,
            default: "true",
            widths: {
              parent: "col-sm-6",
              children: "col-sm-12"
            },
            placeHolder: "input with checkbox",
            label: "Calculate NPA in Days",
            name: "Calculate_NPA",
            description: "Active"
          },
          {
            inputType: "checkbox",
            isRequired: true,
            default: "true",
            widths: {
              parent: "col-sm-6",
              children: "col-sm-12"
            },
            placeHolder: "input with checkbox",
            label: "No Overdue",
            name: "No_Overdue",
            description: "Active"
          },
          {
            inputType: "checkbox",
            isRequired: true,
            default: "true",
            widths: {
              parent: "col-sm-6",
              children: "col-sm-12"
            },
            placeHolder: "input with checkbox",
            label: "Calculate Interest at Receipt",
            name: "Calculate_Interest",
            description: "Active"
          },
          {
            inputType: "checkbox",
            isRequired: true,
            default: "true",
            widths: {
              parent: "col-sm-6",
              children: "col-sm-12"
            },
            placeHolder: "input with checkbox",
            label: "Calculate Interest after expiry",
            name: "Calculate_Interestexpiry",
            description: "Active"
          },
          {
            inputType: "checkbox",
            isRequired: true,
            default: "true",
            widths: {
              parent: "col-sm-6",
              children: "col-sm-12"
            },
            placeHolder: "input with checkbox",
            label: "After expiry additional Interest as Penal",
            name: "Interest_Penal",
            description: "Active"
          },
          {
            inputType: "checkbox",
            isRequired: true,
            default: "true",
            widths: {
              parent: "col-sm-6",
              children: "col-sm-12"
            },
            placeHolder: "input with checkbox",
            label: "Int upto Fortnight at Closing",
            name: "Int_Closing",
            description: "Active"
          },
          {
            inputType: "displaytext",
            widths: {
              parent: "col-sm-12",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "Gold Loan",
            name: "",
            description: ""
          },
          {
            inputType: "displaytext",
            widths: {
              parent: "col-sm-3",
              children: "col-sm-12"
            },
            placeHolder: "Insurance Calculation On",
            label: "Insurance Calculation On",
            name: "Insurance_Calculation",
            description: "Insurance Calculation On"
          },
          {
            inputType: "autocomplete",
            elementProps: {
              stayOpen: false,
              removeSelected: true,
              disabled: false,
              rtl: false
            },
            widths: {
              parent: "col-sm-3",
              children: "col-sm-12"
            },
            options: [
              {
                label: "Normal",
                value: "Normal"
              },
              {
                label: "Normal",
                value: "Normal"
              }
            ],
            ajaxLoad: true,
            ajaxOptions: {
              query: {
                dialect: "mongodb",
                query: "getTDSflag",
                fieldType: "string",
                filters: ["pageData", "tdsflag"]
              },
              label: "display",
              value: "display"
            },
            placeHolder: "Insurance Calculation On",
            name: "Insurance_Calculation",
            description: "Insurance Calculation On"
          },
          {
            inputType: "checkbox",
            isRequired: true,
            default: "true",
            widths: {
              parent: "col-sm-6",
              children: "col-sm-12"
            },
            placeHolder: "input with checkbox",
            label: "Calculate Insurance at Closing",
            name: "Insuranceat_Closing",
            description: "Active"
          },
          {
            inputType: "checkbox",
            isRequired: true,
            default: "true",
            widths: {
              parent: "col-sm-6",
              children: "col-sm-12"
            },
            placeHolder: "input with checkbox",
            label: "Calculate Insurance For gold loan monthly",
            name: "goldloan",
            description: "Active"
          },
          {
            inputType: "checkbox",
            isRequired: true,
            default: "true",
            widths: {
              parent: "col-sm-6",
              children: "col-sm-12"
            },
            placeHolder: "input with checkbox",
            label: "NPA After Maturity Only",
            name: "NPA_Maturity",
            description: "Active"
          },
          {
            inputType: "displaytext",
            widths: {
              parent: "col-sm-12",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "Cash Credit",
            name: "",
            description: ""
          },
          {
            inputType: "checkbox",
            isRequired: true,
            default: "true",
            widths: {
              parent: "col-sm-4",
              children: "col-sm-12"
            },
            placeHolder: "input with checkbox",
            label: "Overdue above Saction for CC",
            name: "Overdue_CC",
            description: "Active"
          },
          {
            inputType: "displaytext",
            widths: {
              parent: "col-sm-3",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "Debit Allowed After Expiry in Days",
            name: "Debitdays",
            description: ""
          },
          {
            inputType: "text",
            widths: {
              parent: "col-sm-3",
              children: "col-sm-12"
            },
            placeHolder: "Debit Allowed After Expiry in Days",
            label: "",
            name: "Debitdays",
            description: ""
          },
          {
            inputType: "displaytext",
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "",
            name: "Debitdays",
            description: ""
          },
          {
            inputType: "displaytext",
            widths: {
              parent: "col-sm-12",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "Installment Loan",
            name: "",
            description: ""
          },
          {
            inputType: "checkbox",
            isRequired: true,
            default: "true",
            widths: {
              parent: "col-sm-4",
              children: "col-sm-12"
            },
            placeHolder: "input with checkbox",
            label: "Calculate InstallmentPenal",
            name: "InstallmentPenal",
            description: "Active"
          },
          {
            inputType: "displaytext",
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "Installment type",
            label: "Installment Type",
            name: "Installment_Type",
            description: "Installment type"
          },
          {
            inputType: "autocomplete",
            elementProps: {
              stayOpen: false,
              removeSelected: true,
              disabled: false,
              rtl: false
            },
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            options: [
              {
                label: "Normal",
                value: "Normal"
              },
              {
                label: "Normal",
                value: "Normal"
              }
            ],
            ajaxLoad: true,
            ajaxOptions: {
              query: {
                dialect: "mongodb",
                query: "getTDSflag",
                fieldType: "string",
                filters: ["pageData", "tdsflag"]
              },
              label: "display",
              value: "display"
            },
            placeHolder: "Installment type",
            name: "Installment_Type",
            description: "Installment type"
          },
          {
            inputType: "displaytext",
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "Od Inst No Calculation",
            label: "Od Inst No Calculation",
            name: "Installment_Type",
            description: "Od Inst No Calculation"
          },
          {
            inputType: "autocomplete",
            elementProps: {
              stayOpen: false,
              removeSelected: true,
              disabled: false,
              rtl: false
            },
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            options: [
              {
                label: "Normal",
                value: "Normal"
              },
              {
                label: "Normal",
                value: "Normal"
              }
            ],
            ajaxLoad: true,
            ajaxOptions: {
              query: {
                dialect: "mongodb",
                query: "getTDSflag",
                fieldType: "string",
                filters: ["pageData", "tdsflag"]
              },
              label: "display",
              value: "display"
            },
            placeHolder: "Od Inst No Calculation",
            name: "Od_Inst_No",
            description: "Od Inst No Calculation"
          },
        ]
      },
      {
        widths: "col-sm-6",
        tab: "deposit",
        subComponents: [
          {
            inputType: "displaytext",
            widths: {
              parent: "col-sm-12",
              children: "col-sm-12"
            },
            placeHolder: "Premature",
            label: "Premature",
            name: "Premature",
            description: "Premature"
          },
          {
            inputType: "checkbox",
            isRequired: true,
            default: "true",
            widths: {
              parent: "col-sm-6",
              children: "col-sm-12"
            },
            placeHolder: "Premature closing Allowed",
            label: "Premature closing Allowed",
            name: "Premature_Allowed",
            description: "Premature closing Allowed"
          },
          {
            inputType: "checkbox",
            isRequired: true,
            default: "true",
            widths: {
              parent: "col-sm-6",
              children: "col-sm-12"
            },
            placeHolder: "No Interest Permature",
            label: "No Interest Permature",
            name: "NoInterestPermature",
            description: "No Interest Permature"
          },
          {
            inputType: "checkbox",
            isRequired: true,
            default: "true",
            widths: {
              parent: "col-sm-12",
              children: "col-sm-12"
            },
            placeHolder: "Permature rate compare with todays rate",
            label: "Permature rate compare with todays rate",
            name: "Permaturerate_Compare",
            description: "Permature rate compare"
          },
          {
            inputType: "checkbox",
            isRequired: true,
            default: "true",
            widths: {
              parent: "col-sm-12",
              children: "col-sm-12"
            },
            placeHolder: "Permature Less than year saving type",
            label: "Permature Less than year saving type",
            name: "Permaturerate_Year",
            description: "Less than year saving type"
          },
          {
            inputType: "checkbox",
            isRequired: true,
            default: "true",
            widths: {
              parent: "col-sm-6",
              children: "col-sm-12"
            },
            placeHolder: "Permature greater than year saving type",
            label: "Permature > year saving type",
            name: "Permaturerate_Yeargreater",
            description: "greater than year saving type"
          },
          {
            inputType: "checkbox",
            isRequired: true,
            default: "true",
            widths: {
              parent: "col-sm-6",
              children: "col-sm-12"
            },
            placeHolder: "Permature Interest Plain",
            label: "Permature Interest Plain",
            name: "Interest_Plain",
            description: "Interest Plain"
          },
          {
            inputType: "displaytext",
            widths: {
              parent: "col-sm-4",
              children: "col-sm-12"
            },
            placeHolder: "Premature rate Less",
            label: "Premature rate Less",
            name: "Prematurerate",
            description: "Premature rate Less"
          }, 
          {
            inputType: "displaytext",
            widths: {
              parent: "col-sm-4",
              children: "col-sm-12"
            },
            placeHolder: "Premature rate Less",
            label: "",
            name: "Prematurerate",
            description: "Premature rate Less"
          }, 
        ]
      },
      {
        widths: "col-sm-6",
        tab: "deposit",
        subComponents: [
          {
            inputType: "displaytext",
            widths: {
              parent: "col-sm-12",
              children: "col-sm-12"
            },
            placeHolder: "Renewal",
            label: "Renewal",
            name: "Renewal",
            description: "Renewal"
          },
          {
            inputType: "checkbox",
            isRequired: true,
            default: "true",
            widths: {
              parent: "col-sm-4",
              children: "col-sm-12"
            },
            placeHolder: "Renew Allowed",
            label: "Renew Allowed",
            name: "Renew_Allowed",
            description: "Renew Allowed"
          },
          {
            inputType: "displaytext",
            widths: {
              parent: "col-sm-5",
              children: "col-sm-12"
            },
            placeHolder: "Premature",
            label: "Renew Allowed In Days",
            name: "renewdays",
            description: "Premature"
          },
          {
            inputType: "text",
            widths: {
              parent: "col-sm-3",
              children: "col-sm-12"
            },
            placeHolder: "Premature",
            label: "",
            name: "renewdays",
            description: "Premature"
          },
          {
            inputType: "checkbox",
            isRequired: true,
            default: "true",
            widths: {
              parent: "col-sm-3",
              children: "col-sm-12"
            },
            placeHolder: "Auto Renew ",
            label: "Auto Renew",
            name: "Auto_Renew",
            description: "Auto Renew"
          },
          {
            inputType: "displaytext",
            widths: {
              parent: "col-sm-6",
              children: "col-sm-12"
            },
            placeHolder: "Auto Renew after expiry in Days",
            label: "Auto Renew after expiry in Days",
            name: "autorenewexpiry",
            description: "Premature"
          },
          {
            inputType: "text",
            widths: {
              parent: "col-sm-3",
              children: "col-sm-12"
            },
            placeHolder: "Auto Renew after expiry in Days",
            label: "",
            name: "autorenewexpiry",
            description: "Auto Renew after expiry in Days"
          },
          {
            inputType: "checkbox",
            isRequired: true,
            default: "true",
            widths: {
              parent: "col-sm-12",
              children: "col-sm-12"
            },
            placeHolder: "Auto Renew For Same Period ",
            label: "Auto Renew For Same Period",
            name: "Auto_Renewperiod",
            description: "Auto Renew For Same Period"
          },
          {
            inputType: "displaytext",
            widths: {
              parent: "col-sm-6",
              children: "col-sm-12"
            },
            placeHolder: "Auto Renew for months,Days",
            label: "Auto Renew for months,Days",
            name: "autorenewmonths",
            description: "for months,Days"
          },
          {
            inputType: "text",
            widths: {
              parent: "col-sm-3",
              children: "col-sm-12"
            },
            placeHolder: "for months,Days",
            label: "",
            name: "autorenewmonths",
            description: "Auto Renew for months,Days"
          },
          {
            inputType: "text",
            widths: {
              parent: "col-sm-3",
              children: "col-sm-12"
            },
            placeHolder: "for months,Days",
            label: "",
            name: "autorenewmonthsdays",
            description: "Auto Renew for months,Days"
          },
        ]
      },
      {
        widths: "col-sm-6",
        tab: "deposit",
        subComponents: [
          {
            inputType: "displaytext",
            widths: {
              parent: "col-sm-12",
              children: "col-sm-12"
            },
            placeHolder: "Maturity",
            label: "Maturity",
            name: "Maturity",
            description: "Maturity"
          },
          {
            inputType: "checkbox",
            isRequired: true,
            default: "true",
            widths: {
              parent: "col-sm-12",
              children: "col-sm-12"
            },
            placeHolder: "Calculate Maturity Amount ",
            label: "Calculate Maturity Amount",
            name: "CalculateMaturityAmount",
            description: "Calculate Maturity Amount"
          },
          {
            inputType: "displaytext",
            widths: {
              parent: "col-sm-6",
              children: "col-sm-12"
            },
            placeHolder: "Fixed Maturity Amount",
            label: "Fixed Maturity Amount",
            name: "fixedmaturity",
            description: "Fixed Maturity Amount"
          },
          {
            inputType: "text",
            widths: {
              parent: "col-sm-6",
              children: "col-sm-12"
            },
            placeHolder: "Fixed Maturity Amount",
            label: "",
            name: "fixedmaturity",
            description: "Fixed Maturity Amount"
          },
          {
            inputType: "displaytext",
            widths: {
              parent: "col-sm-6",
              children: "col-sm-12"
            },
            placeHolder: "Fixed Maturity Amount",
            label: "Fixed Maturity Amount",
            name: "fixedmaturity1",
            description: "Fixed Maturity Amount"
          },
          {
            inputType: "text",
            widths: {
              parent: "col-sm-6",
              children: "col-sm-12"
            },
            placeHolder: "Fixed Maturity Amount",
            label: "",
            name: "fixedmaturity1",
            description: "Fixed Maturity Amount"
          },
          {
            inputType: "checkbox",
            isRequired: true,
            default: "true",
            widths: {
              parent: "col-sm-12",
              children: "col-sm-12"
            },
            placeHolder: "Pay Interest for Holiday on Maturity",
            label: "Pay Interest for Holiday on Maturity",
            name: "payinterest",
            description: "Pay Interest for Holiday on Maturity"
          },
          {
            inputType: "displaytext",
            widths: {
              parent: "col-sm-6",
              children: "col-sm-12"
            },
            placeHolder: "After Maturity Rate",
            label: "After Maturity Rate",
            name: "AfterRate",
            description: "After Maturity Rate"
          },
          {
            inputType: "text",
            widths: {
              parent: "col-sm-6",
              children: "col-sm-12"
            },
            placeHolder: "After Maturity Rate",
            label: "",
            name: "AfterRate",
            description: "After Maturity Rate"
          },
        ]
      },
      {
        widths: "col-sm-6",
        tab: "deposit",
        subComponents: [
          {
            inputType: "displaytext",
            widths: {
              parent: "col-sm-12",
              children: "col-sm-12"
            },
            placeHolder: "Period",
            label: "Period",
            name: "Period",
            description: "Period"
          },
          {
            inputType: "checkbox",
            isRequired: true,
            default: "true",
            widths: {
              parent: "col-sm-4",
              children: "col-sm-12"
            },
            placeHolder: "Fixed Period",
            label: "Fixed Period",
            name: "Fixed_Period",
            description: "Fixed Period"
          },
          {
            inputType: "displaytext",
            widths: {
              parent: "col-sm-4",
              children: "col-sm-12"
            },
            placeHolder: "Months & Days",
            label: "Months & Days",
            name: "MonthsDays",
            description: "Months & Days"
          },
          {
            inputType: "text",
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "Months & Days",
            label: "",
            name: "MonthsDays",
            description: "Months & Days"
          },
          {
            inputType: "text",
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "Months & Days",
            label: "",
            name: "MonthsDays1",
            description: "Months & Days"
          },
        ]
      },
      {
        widths: "col-sm-12",
        tab: "deposit",
        subComponents: [
          {
            inputType: "displaytext",
            widths: {
              parent: "col-sm-3",
              children: "col-sm-12"
            },
            placeHolder: "Interest Payment frequency",
            label: "Interest Payment frequency",
            name: "Interest_Payment",
            description: "Interest Payment frequency"
          },
          {
            inputType: "text",
            widths: {
              parent: "col-sm-3",
              children: "col-sm-12"
            },
            placeHolder: "Interest Payment frequency",
            label: "",
            name: "Interest Payment frequency",
            description: "Interest Payment frequency"
          },
          {
            inputType: "displaytext",
            widths: {
              parent: "col-sm-3",
              children: "col-sm-12"
            },
            placeHolder: "Percentage of FD Loan",
            label: "Percentage of FD Loan",
            name: "PercentageLoan",
            description: "Percentage of FD Loan"
          },
          {
            inputType: "text",
            widths: {
              parent: "col-sm-3",
              children: "col-sm-12"
            },
            placeHolder: "Percentage of FD Loan",
            label: "",
            name: "PercentageLoan",
            description: "Percentage of FD Loan"
          },
          {
            inputType: "checkbox",
            isRequired: true,
            default: "true",
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "Loan Allowed",
            label: "Loan Allowed",
            name: "Loan_Allowed",
            description: "Loan Allowed"
          },
          {
            inputType: "checkbox",
            isRequired: true,
            default: "true",
            widths: {
              parent: "col-sm-4",
              children: "col-sm-12"
            },
            placeHolder: "Want Debit Balance seperate",
            label: "Want Debit Balance seperate",
            name: "Debit_Balance",
            description: "Want Debit Balance seperate"
          },
          {
            inputType: "checkbox",
            isRequired: true,
            default: "true",
            widths: {
              parent: "col-sm-4",
              children: "col-sm-12"
            },
            placeHolder: "Income Tax Benefit",
            label: "Income Tax Benefit",
            name: "Income_Tax",
            description: "Income Tax Benefit"
          },
          {
            inputType: "checkbox",
            isRequired: true,
            default: "true",
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "TDS Deductible",
            label: "TDS Deductible",
            name: "TDS_Deductible",
            description: "TDS Deductible"
          },
          {
            inputType: "checkbox",
            isRequired: true,
            default: "true",
            widths: {
              parent: "col-sm-3",
              children: "col-sm-12"
            },
            placeHolder: "FD Printing On Computer",
            label: "FD Printing On Computer",
            name: "FDPrinting",
            description: "FD Printing On Computer"
          },
          {
            inputType: "checkbox",
            isRequired: true,
            default: "true",
            widths: {
              parent: "col-sm-4",
              children: "col-sm-12"
            },
            placeHolder: "Recreate Total Interest",
            label: "Recreate Total Interest",
            name: "reacreatetotal",
            description: "Recreate Total Interest"
          },
          {
            inputType: "displaytext",
            widths: {
              parent: "col-sm-12",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "Recurring",
            name: "",
            description: ""
          },
          {
            inputType: "displaytext",
            widths: {
              parent: "col-sm-3",
              children: "col-sm-12"
            },
            placeHolder: "Installment Penal rate",
            label: "Installment Penal rate",
            name: "penalrate",
            description: "Installment Penal rate"
          },
          {
            inputType: "text",
            widths: {
              parent: "col-sm-3",
              children: "col-sm-12"
            },
            placeHolder: "Installment Penal rate",
            label: "",
            name: "penalrate",
            description: "Installment Penal rate"
          },
          {
            inputType: "checkbox",
            isRequired: true,
            default: "true",
            widths: {
              parent: "col-sm-6",
              children: "col-sm-12"
            },
            placeHolder: "RD Insallments upto Month End",
            label: "RD Insallments upto Month End",
            name: "rdinstallments",
            description: "RD Insallments upto Month End"
          },
          {
            inputType: "displaytext",
            widths: {
              parent: "col-sm-3",
              children: "col-sm-12"
            },
            placeHolder: "Installment Grace Days",
            label: "Installment Grace Days",
            name: "gracedays",
            description: "Installment Grace Days"
          },
          {
            inputType: "text",
            widths: {
              parent: "col-sm-3",
              children: "col-sm-12"
            },
            placeHolder: "Grace Days",
            label: "",
            name: "gracedays",
            description: "Installment Grace Days"
          },
          {
            inputType: "checkbox",
            isRequired: true,
            default: "true",
            widths: {
              parent: "col-sm-6",
              children: "col-sm-12"
            },
            placeHolder: "Maturity of RD Month End",
            label: "Maturity of RD Month End",
            name: "rdmonthsend",
            description: "Maturity of RD Month End"
          },
          {
            inputType: "displaytext",
            widths: {
              parent: "col-sm-3",
              children: "col-sm-12"
            },
            placeHolder: "Penal Received GL",
            label: "Penal Received GL",
            name: "penalgl",
            description: "Penal Received GL"
          },
          {
            inputType: "autocomplete",
            elementProps: {
              stayOpen: false,
              removeSelected: true,
              disabled: false,
              rtl: false
            },
            widths: {
              parent: "col-sm-3",
              children: "col-sm-12"
            },
            options: [
              {
                label: "Normal",
                value: "Normal"
              },
              {
                label: "Normal",
                value: "Normal"
              }
            ],
            ajaxLoad: true,
            ajaxOptions: {
              query: {
                dialect: "mongodb",
                query: "getTDSflag",
                fieldType: "string",
                filters: ["pageData", "tdsflag"]
              },
              label: "display",
              value: "display"
            },
            placeHolder: "Penal Received GL",
            name: "penalgl",
            description: "Penal Received GL"
          },
          {
            inputType: "checkbox",
            isRequired: true,
            default: "true",
            widths: {
              parent: "col-sm-6",
              children: "col-sm-12"
            },
            placeHolder: "Calculate Penal at the Receipt",
            label: "Calculate Penal at the Receipt",
            name: "penalreceipt",
            description: "Calculate Penal at the Receipt"
          },
          {
            inputType: "displaytext",
            widths: {
              parent: "col-sm-12",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "Pigmy",
            name: "",
            description: ""
          },
          {
            inputType: "displaytext",
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "Pigmy Comm Received",
            label: "Pigmy Comm Received",
            name: "Pigmycomm",
            description: "Pigmy Comm Received"
          },

          {
            inputType: "autocomplete",
            elementProps: {
              stayOpen: false,
              removeSelected: true,
              disabled: false,
              rtl: false
            },
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            options: [
              {
                label: "Normal",
                value: "Normal"
              },
              {
                label: "Normal",
                value: "Normal"
              }
            ],
            ajaxLoad: true,
            ajaxOptions: {
              query: {
                dialect: "mongodb",
                query: "getTDSflag",
                fieldType: "string",
                filters: ["pageData", "tdsflag"]
              },
              label: "display",
              value: "display"
            },
            placeHolder: "Pigmy Comm Received",
            name: "Pigmycomm",
            description: "Pigmy Comm Received"
          },
          {
            inputType: "displaytext",
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "Service Tax GL",
            label: "Service Tax GL",
            name: "Service_GL",
            description: "Service Tax GL"
          },

          {
            inputType: "autocomplete",
            elementProps: {
              stayOpen: false,
              removeSelected: true,
              disabled: false,
              rtl: false
            },
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            options: [
              {
                label: "Normal",
                value: "Normal"
              },
              {
                label: "Normal",
                value: "Normal"
              }
            ],
            ajaxLoad: true,
            ajaxOptions: {
              query: {
                dialect: "mongodb",
                query: "getTDSflag",
                fieldType: "string",
                filters: ["pageData", "tdsflag"]
              },
              label: "display",
              value: "display"
            },
            placeHolder: "Service Tax GL",
            name: "Service_GL",
            description: "Service Tax GL"
          },
          {
            inputType: "displaytext",
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "Pigmy Comm TDS GL",
            label: "Pigmy Comm TDS GL",
            name: "Pigmycomm_GL",
            description: "Pigmy Comm TDS GL"
          },

          {
            inputType: "autocomplete",
            elementProps: {
              stayOpen: false,
              removeSelected: true,
              disabled: false,
              rtl: false
            },
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            options: [
              {
                label: "Normal",
                value: "Normal"
              },
              {
                label: "Normal",
                value: "Normal"
              }
            ],
            ajaxLoad: true,
            ajaxOptions: {
              query: {
                dialect: "mongodb",
                query: "getTDSflag",
                fieldType: "string",
                filters: ["pageData", "tdsflag"]
              },
              label: "display",
              value: "display"
            },
            placeHolder: "Pigmy Comm TDS GL",
            name: "Pigmycomm_GL",
            description: "Pigmy Comm TDS GL"
          },
        ]
      }



  ]
};

export default viewproduct;
